@if (product) {
  <div class="consultant-card-container">
    <a
      class="card-info"
      [href]="router.serializeUrl(router.createUrlTree([product.url]))"
      target="_blank"
      rel="noopener noreferrer"
      (click)="trackProductClick()"
    >
      <div class="card-image">
        @if (!product?.availabilityTrafficLight?.isAddToCart) {
          <div class="out-of-stock-overlay">{{ 'cartItems.soldOut' | cxTranslate }}</div>
        }
        <app-image
          [cloudinaryId]="product.images?.[0]?.cloudinaryPublicId"
          [alt]="product.images?.[0]?.altText"
          [size]="imageSizes.PRODUCT_CARD"
          [preloaded]="false"
          class="product-image"
          [class.grayscale]="!product?.availabilityTrafficLight?.isAddToCart"
        ></app-image>
      </div>
      <div>
        <div class="card-name">{{ product.name }}</div>

        <div class="card-chips">
          <div *ngIf="product.new" class="new" [attr.data-qa]="'product-card-label-new'">
            {{ 'habaProductCard.newTag' | cxTranslate }}
          </div>
          <div *ngIf="false" class="bestseller" [attr.data-qa]="'product-card-label-bestseller'">
            {{ 'habaProductCard.bestsellerTag' | cxTranslate }}
          </div>
          <div *ngIf="product.sale" class="sale" [attr.data-qa]="'product-card-label-sale'">
            {{ '-' + product.sale + '%' }}
          </div>

          <ng-container *ngFor="let label of product?.labels">
            <ng-container *ngIf="label?.key === 'campaign'">
              <!-- 0 = text, 1 = fontColor, 2 = backgroundColor, 3 = imageUrl -->
              <div class="campaign">
                <div
                  [ngStyle]="{
                    'background-color': splitCampaignLabelValue(label?.value)[2],
                    color: splitCampaignLabelValue(label?.value)[1],
                  }"
                  [attr.data-qa]="'product-card-label-campaign'"
                >
                  {{ splitCampaignLabelValue(label?.value)[0] }}
                </div>
              </div>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </a>

    <div class="card-description">
      {{ product.description || '-' }}
    </div>

    <div class="card-price d-none d-md-block">
      <ng-container *ngTemplateOutlet="price"></ng-container>
    </div>

    <div class="card-actions-wrapper">
      <div class="card-price d-block d-md-none">
        <ng-container *ngTemplateOutlet="price"></ng-container>
      </div>

      @if (!product.giftCard) {
        <div class="card-actions">
          <div class="wishlist-button" (click)="addToWishlist($event)">
            <app-product-add-to-wishlist
              [asIcon]="true"
              [baseId]="wishlistBaseQaId"
              [product]="product"
            ></app-product-add-to-wishlist>
          </div>

          @if (!product?.availabilityTrafficLight?.isAddToCart) {
            <button
              class="d-flex justify-content-center"
              appButton
              [fullWidth]="isDesktop"
              type="button"
              [variant]="'primary'"
              (click)="openDialog($event)"
            >
              @if (isDesktop) {
                <span appButtonText class="font-12">{{
                  'backtostockModal.notifyMe' | cxTranslate
                }}</span>
                <app-svg appButtonIcon iconName="Bell" width="20" height="20" />
              } @else {
                <app-svg appButtonIcon iconName="Bell" width="12" height="12" />
              }
            </button>
          } @else {
            <div (click)="addToCart($event)">
              <haba-add-to-cart
                [baseQaId]="baseQaId"
                [product]="product"
                [quantity]="quantityControl.value || 1"
                [quantityControl]="quantityControl"
                [productCardBase]="true"
                [asIcon]="!isDesktop"
              />
            </div>
          }
        </div>
      }
    </div>
  </div>

  <ng-template #price>
    <div class="d-flex gap-4">
      <span *ngIf="product.configurable || product.giftCard">{{
        'habaProductCard.from' | cxTranslate
      }}</span>

      <app-product-price-display
        [align]="'left'"
        [qa]="priceTextId?.getTextId()"
        [price]="{
          value: product.giftCard ? 10 : product.price,
        }"
        [strikeThroughPrice]="{ value: product.strikeThroughPrice }"
        [currency]="product.currencyIso"
        [netValue]="product.netPrice"
        [isProductList]="true"
      />

      <span [attr.data-qa]="basePrice?.getTextId()" *ngIf="product.basePriceFormatted?.length > 0">
        ({{ product.basePriceFormatted }})
      </span>
    </div>
  </ng-template>

  <ng-container *ngIf="selectedProduct">
    <app-add-to-cart-popup
      [product]="selectedProduct"
      [quantity]="quantityControl.value || 1"
    ></app-add-to-cart-popup>
  </ng-container>

  <ng-container *ngIf="selectedProduct?.configurable">
    <app-configuration-overlay
      [product]="selectedProduct"
      (popupClosed)="popupClosed($event)"
    ></app-configuration-overlay>
  </ng-container>
}
